var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInclusionpsychologicalSafety(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12L11 14L15 10",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C14.3358 5.06658 17.3845 6.14257 20.5 6C20.9536 7.54302 21.0924 9.16147 20.9081 10.7592C20.7239 12.3569 20.2203 13.9013 19.4274 15.3005C18.6345 16.6998 17.5684 17.9254 16.2925 18.9045C15.0165 19.8836 13.5568 20.5962 12 21C10.4432 20.5962 8.98348 19.8836 7.70755 18.9045C6.43161 17.9254 5.36551 16.6998 4.5726 15.3005C3.77968 13.9013 3.27614 12.3569 3.09188 10.7592C2.90762 9.16147 3.04641 7.54302 3.5 6C6.61553 6.14257 9.66417 5.06658 12 3",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInclusionpsychologicalSafety);
export default __webpack_public_path__ + "static/media/inclusion.psychologicalSafety.0f25fa301e21199b2f8bcabf5d00167e.svg";
export { ForwardRef as ReactComponent };